import { Component } from "@angular/core";
import { Router } from "@angular/router";

@Component({
  selector: "app-identity-provisioning",
  templateUrl: "./identity-provisioning.component.html",
  styleUrls: ["./identity-provisioning.component.scss"],
})
export class IdentityProvisioningComponent {
  constructor(private router: Router) {}

  aggregateEmpDetails() {
    this.router.navigate([
      "digital-identity/auth-tools/identity-provisioning/import-emp-info",
    ]);
  }
  assignDigitalId() {
    this.router.navigate([
      "digital-identity/auth-tools/identity-provisioning/assign-digital-id",
    ]);
  }
}
